<template>
  <div class="buy_class">
    <!-- 课程卡片 -->
    <div class="card">
      <div class="classCard" v-for="(item,index) in classcardList" :key="index">
        <p class="title_p">{{item.name}}</p>
        <p class="text_p">{{item.schoolTimeName}} · 共{{item.syllabusNum}}讲</p>
        <p class="level_p">
          难度
          <van-rate
            :size="14"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
            :count="item.difficulty.alias"
            v-model="item.difficulty.alias"
          />
        </p>
        <div class="teacher_p">
          <dl class="teacherdl">
            <dt>
              <img :src="item.chineseTeacher[0].avatars" />
            </dt>
            <dd>
              <p class="typename_p">{{item.chineseTeacher[0].typeName}}</p>
              <p class="name_p">{{item.chineseTeacher[0].name}}</p>
            </dd>
          </dl>
          <dl class="teacher_dl">
            <dt>
              <img :src="item.class.counselor.avatars" />
            </dt>
            <dd>
              <p class="typename_p">{{item.class.counselor.typeName}}</p>
              <p class="name_p">{{item.class.counselor.name}}</p>
            </dd>
          </dl>
        </div>
        <p class="line_p"></p>
        <p class="surplus_p">剩余{{item.class.leftNum}}个名额</p>
        <p class="buy_p">
          <img src="../assets/getcoupons/yiyuan_buyclass.png" @click="buyclass(item,index)" />
        </p>
      </div>
    </div>

    <!-- 客服  按钮-->
    <customer-service :position="605" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Rate, Dialog } from 'vant'

import customerService from '../components/customerService'

Vue.use(Rate)
export default {
  name: 'buyClass',
  components: {
    'customer-service': customerService
  },
  data() {
    return {
      classcardList: [],
      isInApp: false,
      nowPage: 1,
      gradeId: JSON.parse(sessionStorage.getItem('selectInfo')).gradeId,
      subjectId: JSON.parse(sessionStorage.getItem('selectInfo')).subjectId,
      difficultyId: JSON.parse(sessionStorage.getItem('selectInfo')).difficultyId,
      page: JSON.parse(sessionStorage.getItem('selectInfo')).page
    }
  },
  created() {
    this.getClassList()
    console.log('============', window.sessionStorage.getItem('isBack'))
    if (window.sessionStorage.getItem('isBack') == 1) {
      this.$router.replace({
        name: 'payPage'
      })
    }
    window.addEventListener('scroll', this.lazyLoading)
  },
  mounted() {
    this.isInApp = this.isApp()
  },
  methods: {
    // 获取课程列表
    async getClassList(params) {
      const res = await this.$api.getClassList({
        // params: JSON.parse(sessionStorage.getItem("selectInfo")),
        params: {
          gradeId: this.gradeId,
          subjectId: this.subjectId,
          difficultyId: this.difficultyId,
          page: this.page
        }
      })
      if (res.code === 0) {
        const getClassList = res.data || {}
        this.classcardList = getClassList.courseList
        console.log(this.classcardList)
      } else {
        this.$xesAlert({
          title: '提示',
          message: res.msg,
          sureText: '我知道了',
          type: alert,
          onSure: () => {
            this.$router.push({
              name: 'getCoupons'
            })
          },
          onCancel: () => {}
        })
      }
    },
    // 滑动到底部刷新
    // lazyLoading
    lazyLoading() {
      const dom = document.documentElement
      const scrollTop = dom.scrollTop || document.body.scrollTop
      const clientHeight = dom.clientHeight
      const scrollHeight = dom.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.classcardList.totalPage > this.page) {
          this.page += 1
          this.getClassList()
        }
      }
    },

    // 判断当前环境是否在app内
    isApp() {
      return /jzh$/.test(navigator.userAgent.toLowerCase())
    },

    // 点击0元购课
    async buyclass(item, index, params) {
      const res = await this.$api.isReceiveCoupon({
        // 校验是否拥有领券的资格
        params: {
          courseId: item.id,
          confirm: 0
        }
      })
      if (res.code === 0) {
        // 0 代表拥有领券的资格
        this.$xesAlert({
          type: 'confirm',
          title: '确认使用0元领取此课程？',
          message: '只有一次0元领课机会 ',
          sureText: '确认领课',
          cancelText: '取消',
          onSure: async() => {
            const resu = await this.$api.isReceiveCoupon({
              // 调用确认是否要领券的接口
              params: {
                courseId: item.id,
                // courseId: 266103,
                confirm: 1
              }
            })
            if (resu.code === 0) {
              // 确认领券 跳商场页面
              if (this.isInApp) {
                this.$api.getClassId(item.id).then((result) => {
                  if (result.code == 0) {
                    const _d = JSON.stringify({
                      p: {
                        courseIds: `${item.id}-${result.data.classId}`,
                        productType: 100
                      }
                    })
                    // this.courseId = ''
                    window.sessionStorage.setItem('isBack', 1)
                    window.location.href = `xeswangxiao://xrsApp?m=xesmallOrderConfirm&en=0&d=${_d}`
                  }
                })
              } else {
                console.log(88888, item.id)
                this.$api.getPayUrl(item.id).then((result) => {
                  if (result.code == 0) {
                    window.sessionStorage.setItem('isBack', 1)
                    window.location.href = result.data.buyUrl
                  } else if (result.code == 2) {
                    this.$toast('已报满 正在紧急加开名额')
                  } else {
                    this.$toast(result.message)
                  }
                })
              }
            } else {
              this.$xesAlert({
                title: '提示',
                message: resu.msg,
                sureText: '我知道了',
                type: alert
              })
            }
          },
          onCancel: () => {}
        })
      } else if (res.code === 11014) {
        this.$xesAlert({
          title: '提示',
          message: res.msg,
          sureText: '查看已选课程',
          onSure: () => {
            this.$router.push({
              name: 'payPage'
            })
          },
          onCancel: () => {}
        })
      } else {
        this.$xesAlert({
          title: '提示',
          message: res.msg,
          sureText: '我知道了',
          type: alert
        })
      }

      // 点击1元购课的埋点
      this.$xesLogger.clickMsg({
        params: {
          pageuid: 'activitiesPage6',
          clickid: 4,
          action: 'click_buy2_uv',
          clickname: '点击0元购课'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.buy_class {
  width: 100%;
  min-height: 100vh;
  background: #f2f2f2;

  .card {
    width: 100%;
    overflow: hidden;

    .classCard {
      width: 94%;
      margin: 0 auto;
      margin-top: 10px;
      background: #fff;
      border-radius: 4px;

      .title_p {
        width: 100%;
        padding: 20px 26px 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #212831;
      }

      .text_p {
        width: 100%;
        padding: 12px 0 0 16px;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
        color: #5b6169;
      }

      .level_p {
        width: 100%;
        padding: 12px 0 0 16px;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
        color: #5b6169;
      }

      .teacher_p {
        width: 100%;
        height: 35px;
        margin-top: 16px;

        .teacherdl {
          float: left;
          width: 120px;
          height: 35px;
          margin-left: 16px;

          dt {
            float: left;

            img {
              width: 32px;
              height: 32px;
              border: 1px solid #e0e1ef;
              border-radius: 50%;
            }
          }

          dd {
            float: left;
            margin-left: 6px;

            .typename_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              color: #878e9a;
            }

            .name_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 12px;
              color: #5e617c;
            }
          }
        }

        .teacher_dl {
          float: left;
          width: 120px;
          height: 35px;
          margin-left: 16px;

          dt {
            float: left;

            img {
              width: 32px;
              height: 32px;
              border: 1px solid #e0e1ef;
              border-radius: 50%;
            }
          }

          dd {
            float: left;
            margin-left: 6px;

            .typename_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              color: #878e9a;
            }

            .name_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 12px;
              color: #5e617c;
            }
          }
        }
      }

      .line_p {
        width: 90%;
        margin: 0 auto;
        margin-top: 16px;
        border-top: 1px solid #f2f2f2;
      }

      .surplus_p {
        float: left;
        // width: 100px;
        padding: 13px 0 13px 16px;
        font-size: 12px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 24px;
        color: #5b6169;
      }

      .buy_p {
        padding: 11px 16px 11px 260px;
        font-size: 0;

        img {
          width: 74px;
          height: 28px;
        }
      }
    }

    .classCard:last-child {
      margin-bottom: 20px;
    }
  }
}
</style>
